import { useEffect } from 'react'
import { AppMobile } from './app.mobile'
import { AppDesktop } from './app.desktop'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { usePrevious } from '$common/react-hooks/use-previous'

export function App() {
  const isDesktop = useIsDesktopSize()
  const prevIsDesktop = usePrevious(isDesktop)

  //TODO: Implement mobile->desktop | desktop->mobile transition in router's state. but for now, reloading window is sufficient
  useEffect(() => {
    if (isDesktop !== undefined && prevIsDesktop !== undefined)
      window.location.reload()
  }, [isDesktop])

  return isDesktop ? <AppDesktop /> : <AppMobile />
}
